import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { alertErrorMessage } from '../../../utils/Errors'
import { getUrlWithVersion } from '../../../api/api'

export const fetchProductLogs = createAsyncThunk<
    any[],
    void,
    ThunkConfig<string>
>('logsSlice/fetchProductLogs', async (_args, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
    } = thunkAPI

    try {
        const { data } = await api.get(getUrlWithVersion(`/logs`))

        return data
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('Failed to fetch product logs')
    }
})
